import styled from "styled-components"

import { colors } from "@minuthq/meatball-ui-react"

import { SVGElement, SVGProps } from "src/utils/tsUtil"

export function RoundStatusIcon({
  variant = "default",
  iconSize = 18,
  icon,
  size = 24,
  ...rest
}: {
  icon: SVGElement
  iconSize?: number
  variant?: "default" | "disabled" | "off" | "emergency"
  size?: number
} & SVGProps) {
  const Icon = icon

  return (
    <RoundIconWrapper
      $backgroundColor={variantStyles[variant].backgroundColor}
      $size={size}
    >
      <Icon width={iconSize} fill={variantStyles[variant].fill} {...rest} />
    </RoundIconWrapper>
  )
}
const variantStyles: Record<
  "default" | "disabled" | "off" | "emergency",
  { backgroundColor: string; fill: string }
> = {
  default: {
    backgroundColor: colors.systemInfoLight,
    fill: colors.systemInfoDark,
  },
  disabled: {
    backgroundColor: colors.systemInfoLight,
    fill: colors.accentPrimary,
  },
  off: {
    backgroundColor: colors.neutralDark,
    fill: colors.neutral,
  },
  emergency: {
    backgroundColor: colors.systemErrorLight,
    fill: colors.systemErrorDark,
  },
}

const RoundIconWrapper = styled.div<{
  $backgroundColor?: string
  $size?: number
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border-radius: 100%;
`
